// assets/variant-media-switch.js
document.addEventListener('DOMContentLoaded', function () {
  // Get all media elements that have variant IDs annotated
  function getMediaEls() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-variant-ids]')
    );
  }

  function parseVariantIds(attr) {
    if (!attr) return [];
    return attr
      .split(',')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function rebuildMap() {
    var els = getMediaEls();
    return els.map(function (el) {
      var raw = el.getAttribute('data-variant-ids') || '';
      return {
        el: el,
        variantIds: parseVariantIds(raw),
      };
    });
  }

  var mediaMap = rebuildMap();

  function showMediaForVariant(variantId) {
    // If no variant or invalid → show all
    if (!variantId) {
      mediaMap.forEach(function (m) {
        m.el.style.display = '';
      });
      return;
    }

    var vstr = String(variantId);
    var anyMatch = mediaMap.some(function (m) {
      return m.variantIds.indexOf(vstr) !== -1;
    });

    // If variant has no specific media → show all (Shopify default behavior)
    if (!anyMatch) {
      mediaMap.forEach(function (m) {
        m.el.style.display = '';
      });
      return;
    }

    // Otherwise show only media for this variant
    mediaMap.forEach(function (m) {
      if (m.variantIds.indexOf(vstr) !== -1) {
        m.el.style.display = '';
      } else {
        m.el.style.display = 'none';
      }
    });
  }

  function findVariantElement() {
    // Most themes: variant selector inside add-to-cart form
    var el = document.querySelector(
      'form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
    );
    if (el) return el;

    // Fallback: any id input/select
    return document.querySelector('input[name="id"], select[name="id"]');
  }

  var variantEl = findVariantElement();

  function onVariantChange(val) {
    mediaMap = rebuildMap();
    showMediaForVariant(val);
  }

  if (variantEl) {
    variantEl.addEventListener('change', function () {
      onVariantChange(variantEl.value || null);
    });

    // Initial run on page load
    onVariantChange(variantEl.value || null);
  } else {
    // Fallback: handle themes using buttons/swatches without direct change events
    document.addEventListener(
      'click',
      function () {
        setTimeout(function () {
          var el = findVariantElement();
          var val = el ? el.value : null;
          onVariantChange(val);
        }, 80);
      },
      true
    );
  }

  // In case the gallery is re-rendered (e.g. via theme scripts), keep media map fresh
  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      mediaMap = rebuildMap();
      var current =
        variantEl && variantEl.value ? variantEl.value : null;
      showMediaForVariant(current);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
});
